var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRatio = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 .038V13.35a.5.5 0 0 0 .288.453l.077.028 12.861 3.597C23.415 22.428 18.625 26 13 26 5.82 26 0 20.18 0 13 0 6.285 5.09.76 11.623.072c.126-.013.251-.025.377-.034zm2 0C20.714.548 26 6.157 26 13c0 .855-.083 1.69-.24 2.5l-11.395-3.19a.5.5 0 0 1-.358-.4L14 11.828V.038z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRatio);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ratio.ac445169a49ee7f3c559f1fc979a107a.svg";